'use strict';
angular.module('resourceCenterServiceModule', []).factory('resourceCenterService', [
    '$q',
    '$state',
    '$stateParams',
    '$timeout',
    'trsHttpService',
    '$sessionStorage',
    'localStorageService',
    'versionCtrl',
    'resourceApiService',
    '$modal',
    'publicToolService',
    function($q, $state, $stateParams, $timeout, trsHttpService, $sessionStorage, localStorageService, versionCtrl, resourceApiService, $modal, publicToolService) {
        var rooturl = trsHttpService.getBigDataRootUrl();
        var wcmurl = trsHttpService.getWCMRootUrl();
        var isSzbPage = false;
        var delectXjSelected = false;
        initData();

        /**
         * [initData description]是否删除新疆筛选
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            publicToolService.getModeconfiguration('delectXjSelected', 'copyrightResource').then((config) => {
                delectXjSelected = config;
            });
        }

        /**
         * 获取真实参数
         */
        function getRealParams() {
            var params = {};
            var orgParams = window.location.href;
            orgParams = orgParams.substring(orgParams.indexOf('?') + 1);
            orgParams = orgParams.split('&');
            for (var i = 0; i < orgParams.length; i++) {
                var objName = orgParams[i].substring(0, orgParams[i].indexOf('='));
                var objValue = orgParams[i].substring(orgParams[i].indexOf('=') + 1);
                params[objName] = objValue;
            }
            return params;
        }

        function getRealRouterName() {
            var curUrl = window.location.href;
            var currentRouter = curUrl.substring(curUrl.indexOf('#/') + 2, curUrl.indexOf('?')).replace(/\//g, '.');
            return currentRouter;
        }
        return {
            // 左侧列表
            getBase: function(extraparams) {
                var params = {
                    serviceid: 'navigation',
                    typeid: 'zyzx',
                    modelid: 'base',
                    parentId: -1,
                    level: 1,
                    excludeId: -1,
                    containParent: true,
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(rooturl, params, 'post');
            },
            setSzbPage: function(val) {
                isSzbPage = val;
            },

            getSzbPage: function() {
                return isSzbPage;
            },

            getSingle: function(extraparams) {
                var params = {
                    serviceid: 'navigation',
                    typeid: 'zyzx',
                    modelid: 'single',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(rooturl, params, 'post');
            },
            // 共享稿库右侧列表
            queryTongYiGongGao: function(extraparams) {
                var params = {
                    serviceid: 'mlf_releaseSource',
                    methodname: 'queryTongYiGongGao',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            // 共享稿库本媒体稿
            // queryMediaRelease: function(extraparams) {
            //     var params = {
            //         "serviceid": "mlf_releasesource",
            //         "methodname": "queryMediaRelease"
            //     };
            //     params = angular.extend(params, extraparams);
            //     return trsHttpService.httpServer(wcmurl, params, "post");
            // },
            // 获取右侧列表
            getListbyItem: function(extraparams) {
                var params = {
                    modelid: 'findFromNavigation',
                    typeid: 'zyzx',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(rooturl, params, 'post');
            },
            // 未更新条目数
            getPageInfobyItem: function(extraparams) {
                var params = {
                    modelid: 'getNumberOfNewRecords',
                    typeid: 'zyzx',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(rooturl, params, 'post');
            },
            // 收藏 wcm
            collectDocs: function(extraparams) {
                var params = {
                    typeid: 'zyzx',
                    serviceid: 'mlf_myrelease',
                    methodname: 'collect',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            // 导出操作
            exportDraft: function(ids) {
                var params = {
                    serviceid: 'mlf_exportword',
                    methodname: 'exportWordFile',
                    MetaDataIds: ids,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                    function(data) {
                        // window.open(data);
                        window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                    },
                    function(data) {
                        if (data.REPORTS[0].ISSUCCESS == 'true') {
                            window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                        }
                    }
                );
            },
            // 导出 大数据
            exportBigDataDraft: function(ids, channelName, indexName) {
                var params = {
                    serviceid: 'mlf_exportword',
                    methodname: 'exportBigDataDocs',
                    GUIDS: ids,
                    CHANNELNAMES: channelName,
                    indexName: indexName,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    // window.open(data);
                    window.open('/wcm/app/file/read_file.jsp?FileName=' + data);
                });
            },
            // 收藏 大数据
            collectBigDataDocs: function(extraparams) {
                var params = {
                    typeid: 'zyzx',
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'collect',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            // 加入个人素材
            setCreation: function(extraparams) {
                var params = {
                    typeid: 'zyzx',
                    methodname: 'batchPersonalMaterialOfTxt',
                    PersonalMaterialId: '0',
                    serviceid: 'mlf_releasesource',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            // 加入大数据个人素材
            setBigDataCreation: function(extraparams) {
                var params = {
                    typeid: 'zyzx',
                    methodname: 'batchPersonalMaterial',
                    PersonalMaterialId: '0',
                    serviceid: 'mlf_bigdataexchange',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            // 加入大数据个人素材
            setBigDataBatchCreation: function(extraparams) {
                var params = {
                    typeid: 'zyzx',
                    methodname: 'batchPersonalMaterial',
                    PersonalMaterialId: '0',
                    serviceid: 'mlf_bigdataexchange',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            // 取稿－－共享稿库
            getFetch: function(extraparams) {
                var params = {
                    typeid: 'zyzx',
                    methodname: 'fetch',
                    serviceid: 'mlf_releasesource',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            // 取稿－－大数据
            getBigDataFetch: function(extraparams) {
                var params = {
                    typeid: 'zyzx',
                    methodname: 'fetch',
                    serviceid: 'mlf_bigdataexchange',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            // 预留 wcm
            delayFetch: function(extraparams) {
                var params = {
                    typeid: 'zyzx',
                    methodname: 'delayFetch',
                    serviceid: 'mlf_fusionmyrelease',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            // 预留 大数据
            delayBigDataFetch: function(extraparams) {
                var params = {
                    typeid: 'zyzx',
                    methodname: 'delay',
                    serviceid: 'mlf_bigdataexchange',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            getTags: function(extraparams) {
                var params = {
                    methodname: 'queryFlag',
                    serviceid: 'mlf_bigdataexchange',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            getWcmTags: function(extraparams) {
                var params = {
                    methodname: 'queryFlag',
                    serviceid: 'mlf_releasesource',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            getOperTags: function(extraparams) {
                var params = {
                    methodname: 'queryOpers',
                    serviceid: 'mlf_releasesource',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            getOperations: function(extraparams) {
                var params = {
                    methodname: 'queryOperations',
                    serviceid: 'mlf_releaseSource',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            getTenantOperTags: function(extraparams) {
                var params = {
                    methodname: 'queryFlagList',
                    serviceid: 'mlf_PluralisticShare',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            getPropagandaOperTags: function(extraparams) {
                var params = {
                    methodname: 'queryFlagList',
                    serviceid: 'mlf_pm',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            getXhsgOperTags: function(extraparams) {
                var params = {
                    methodname: 'queryFlagList',
                    serviceid: 'mlf_xinhuasheSource',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            getBigDataOperTags: function(extraparams) {
                var params = {
                    methodname: 'queryFlagList',
                    serviceid: 'mlf_bigdataexchange',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            // 下拉列表数据
            getListDownData: function(extraparams, menuName, callback) {
                var params = {
                    typeid: 'zyzx',
                    modelid: 'getSearchMenu',
                };
                params = angular.extend(params, extraparams);
                params.menuName = menuName;
                trsHttpService.httpServer(rooturl, params, 'post').then(function(data) {
                    if (typeof data === 'object') {
                        var content = data.content && data.content[0];
                        angular.forEach(content, function(n, i) {
                            n.name = n.ENNAME;
                            n.value = n.CNNAME;
                        });
                        typeof callback === 'function' && callback(content);
                    }
                });
            },
            getRetrievalRootList: function(extraparams) {
                var params = {
                    typeid: 'dicttool',
                    modelid: 'getRootLevel',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(rooturl, params, 'post');
            },
            getRetrievalChildren: function(extraparams) {
                var params = {
                    typeid: 'dicttool',
                    modelid: 'getChildren',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(rooturl, params, 'post');
            },
            getWechatSearch: function(extraparams) {
                var params = {
                    typeid: 'zyzx',
                    modelid: 'getAccount',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(rooturl, params, 'post');
            },
            // 共享稿库 稿件详情
            getNewsDoc: function(extraparams) {
                var params = {
                    methodname: 'getNewsDoc',
                    serviceid: 'mlf_myrelease',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            // 获取表格标题列表
            getSummaryFields: function(tableEnName) {
                var params = {
                    typeid: 'zyzx',
                    modelid: 'getSummaryFields',
                    serviceid: 'person',
                    tableEnName: tableEnName || '',
                };
                return trsHttpService.httpServer(rooturl, params, 'post');
            },
            operationSummarys: function(extraparams) {
                var params = {
                    typeid: 'zyzx',
                    modelid: 'operationSummarys',
                    serviceid: 'person',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(rooturl, params, 'post');
            },
            // wcm删除稿件
            deleteRelease: function(ids) {
                var params = {
                    methodname: 'deleteRelease',
                    serviceid: 'mlf_releasesource',
                    MetaDataIds: ids,
                };
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            // 共享稿库普通删除
            commonDeleteRelease: function(ids, nodeid) {
                var params = {
                    methodname: 'deleteReleaseOfMyDoc',
                    serviceid: 'mlf_releaseSource',
                    MetaDataIds: ids,
                    nodeIds: nodeid || null,
                };
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            // 共享稿库管理员删除
            adminDeleteRelease: function(ids, nodeid) {
                var params = {
                    methodname: 'deleteRelease',
                    serviceid: 'mlf_releasesource',
                    MetaDataIds: ids,
                    nodeIds: nodeid || null,
                };
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            // 搜索建议
            getSuggestion: function(extraparams) {
                var params = {
                    typeid: 'zyzx',
                    modelid: 'getSuggestion',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(rooturl, params, 'post');
            },
            getEsDataList: function(extraparams) {
                var params = {
                    methodname: 'queryForTongYiGongGaoDoc',
                    serviceid: 'mlf_hybasesearch',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            getSubscribe: function(methodid, extraparams) {
                var params = {
                    typeid: 'zyzx',
                    modelid: methodid,
                    serviceid: 'subscript',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(rooturl, params, 'post');
            },
            
            /**
             * [expertSearch description] 高级检索
             * @param   {[type]}  extraparams  [extraparams description]
             * @return  {[type]}               [return description]
             */
            expertSearch: function(extraparams) {
                var params = {
                    typeid: 'zyzx',
                    modelid: 'expertSearch',
                    serviceid: 'iwo',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(rooturl, params, 'post');
            },

            /**
             * [subscibeSearch description] iwo资源 获取条件
             * @param   {[type]}  extraparams  [extraparams description]
             * @return  {[type]}               [return description]
             */
            subscibeSearch: function(extraparams) {
                var params = {
                    typeid: 'zyzx',
                    modelid: 'subscibeSearch',
                    serviceid: 'subscript',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(rooturl, params, 'post');
            },

            /**
             * [findSourceById description] iwo资源 获取条件
             * @param   {[type]}  extraparams  [extraparams description]
             * @return  {[type]}               [return description]
             */
            findSourceById: function(extraparams) {
                var params = {
                    typeid: 'zyzx',
                    modelid: 'findSourceById',
                    serviceid: 'subscript',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(rooturl, params, 'post');
            },

            /**
             * [queryForShareContentDoc description] 共享稿库 es检索
             * @param   {[type]}  extraparams  [extraparams description]
             * @return  {[type]}               [return description]
             */
            queryForShareContentDoc: function(extraparams) {
                var params = {
                    methodname: 'queryForShareTopicAndArea',
                    serviceid: 'mlf_essearch',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },

            /**
             * [saveMyCustom description] 设置常用
             * @param   {[type]}  extraparams  [extraparams description]
             * @return  {[type]}               [return description]
             */
            saveMyCustom: function(extraparams) {
                var params = {
                    methodname: 'saveMyCustom',
                    serviceid: 'mlf_releasesource',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },

            /**
             * [queryMyCustoms description] 查找设置常用的
             * @param   {[type]}  CustomType  [CustomType description]
             * @return  {[type]}              [return description]
             */
            queryMyCustoms: function(CustomType) {
                var params = {
                    methodname: 'queryMyCustoms',
                    serviceid: 'mlf_releasesource',
                    CustomType: CustomType || '',
                };
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },
            cancleMyCustom: function(extraparams) {
                var params = {
                    methodname: 'cancleMyCustom',
                    serviceid: 'mlf_releasesource',
                };
                params = angular.extend(params, extraparams);
                return trsHttpService.httpServer(wcmurl, params, 'post');
            },

            /**
             * [getKeywordsOrAbstract description] 提取关键字和摘要
             * @param  {[type]} type    [description]
             * @param  {[type]} content [description]
             * @return {[type]}         [description]
             */
            getKeywordsOrAbstract: function(type, content) {
                var deferred = $q.defer();
                if (!content) {
                    deferred.reject('正文为空');
                }
                var params = {
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'getKeywords',
                    markType: type || 'keywords',
                    markContent: content,
                    // needStop:false,//敏感词
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    deferred.resolve(data);
                });
                return deferred.promise;
            },

            /**
             * [scrollTop description] 定位到顶部
             * @param  {[type]} $element [description] 滚动区dom元素
             * @return {[type]}          [description]
             */
            scrollTop: function($element) {
                $element.find('*[trs-height]').animate({ scrollTop: 0 }, 'fast');
            },

            /**
             * [hasNavigationMemory description] 判断是否有路由记忆
             * @param   {[string]}  name   [name description] 导航名称
             * @param   {[object]}  scope  [scope description] 当前页面scope对象
             * @return  {[type]}           [return description]
             */
            hasNavigationMemory: function(name, scope) {
                var navigationMemory = !!localStorage['resNavigationMemory'] ? JSON.parse(localStorage['resNavigationMemory']) : {};
                $timeout(function() {
                    scope.$on('$destroy', function() {
                        navigationMemory = !!localStorage['resNavigationMemory'] ? JSON.parse(localStorage['resNavigationMemory']) : {};
                        navigationMemory[name] = window.location.href;
                        navigationMemory['version'] = '201803180129'; // 注入版本号，此版本号暂时固化
                        localStorage['resNavigationMemory'] = JSON.stringify(navigationMemory);
                    });
                }, 100);
                return !!navigationMemory[name];
            },

            /**
             * [getNavigationMemory description] 获取导航记忆
             * @param {[string]} [name] [description] 导航名称
             * @return {[type]} [description]
             */
            navigationMemory: function(name) {
                var deffer = $q.defer();
                var navigationMemory = !!localStorage['resNavigationMemory'] ? JSON.parse(localStorage['resNavigationMemory']) : {};
                var routerData = navigationMemory[name];
                if (navigationMemory.version === undefined) {
                    // 没有版本号的数据为脏数据，删除
                    localStorage.removeItem('resNavigationMemory');
                    deffer.resolve();
                } else if (routerData) {
                    if (routerData.indexOf(name) >= 0) {
                        window.location.href = routerData;
                    } else {
                        delete navigationMemory[name];
                        localStorage['resNavigationMemory'] = JSON.stringify(navigationMemory);
                    }
                    deffer.resolve();
                } else {
                    deffer.resolve();
                }
                return deffer.promise;
            },

            /**
             * [go description] 路由自动跳转，快速预览条快速预览，普通视图跳普通视图
             * @param   {[type]}  willRouter  [willRouter description]
             * @param   {[type]}  params      [params description]
             * @return  {[type]}              [return description]
             */
            go: function(willRouter, params) {
                var curRouter = $state.current.name;
                if (curRouter.indexOf('quickpreview') >= 0 && willRouter.indexOf('xinhua') < 0) {
                    var willRouterArray = willRouter.split('.');
                    willRouterArray[willRouterArray.length - 1] = 'quickpreview';
                    var tempWillRouter = willRouterArray.join('.');
                    willRouter = $state.href(tempWillRouter) ? tempWillRouter : willRouter;
                    params.guid = '';
                }
                $state.go(willRouter, params, { reload: willRouter });
            },

            /**
             * [getArea description] 更多筛选中的地区选择
             * @param   {[type]}  node  [node description]选中的地区对象
             * @return  {[type]}        [return description]
             */
            getArea: function(node) {
                var deffer = $q.defer();
                var params = resourceApiService.getAreaParams();
                params.parentId = node.id;
                if (angular.isUndefined(node.id)) {
                    var rootNode = [
                        {
                            dictName: '所有地域',
                            id: '', 
                        },
                        // {
                        //     dictName: '新疆',
                        //     id: 'area_001015',
                        // },
                        {
                            dictName: '全国',
                            id: 'area_001',
                        },
                        {
                            dictName: '海外',
                            id: '-1',
                        },
                    ];
                    if (delectXjSelected !== 'true'){
                        rootNode.splice(1, 0, {
                            dictName: '新疆',
                            id: 'area_001015',
                        });
                    }
                    deffer.resolve(rootNode);
                } else {
                    params.excludeId = (node.id === 'area_001' && 'area_001020') || (node.id === '-1' && 'area_001') || '-1';
                    resourceApiService.getArea(params).then(function(data){
                        deffer.resolve(data);
                    });
                }
                return deffer.promise;
            },

            /**
             * [options 图集轮播弹窗]
             *
             * @param   {[type]}  options  [options description]
             *
             * @return  {[type]}           [return description]
             */
            showAtlasCarouselWindow: function (options) {
                var deffer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/service/modal/atlasCarouselWindow/atlasCarouselWindow_tpl.html',
                    windowClass: 'atlas-carousel-window',
                    backdrop: false,
                    keyboard: false,
                    controller: 'atlasCarouselWindowCtrl',
                    resolve: {
                        options: options
                    },
                });
                modalInstance.result.then(function (result) {
                    deffer.resolve(result);
                });
                return deffer.promise;
            },

            /**
             * [type description] 版权和资源中心记忆只有一级导航
             *
             * @param  {[type]}  type   [type description] 在记忆对象中的key值
             *
             * @return  {[type]}   [return description]
             */
            memoryEchoOnlyLevel1: function(type) {
                var userId = $sessionStorage.get('curUserInfo').ID;
                var state = localStorageService.get('global.state') || {};
                if (state[userId] && state[userId][type]) {
                    $state.transitionTo(state[userId][type].url, state[userId][type].query, {
                        reload: false
                    });
                }
            },
            memoryEchoLevel1: function (e, type) {
                var $dom = $($(e.currentTarget).next()[0]);
                var userId = $sessionStorage.get('curUserInfo').ID;
                var state = localStorageService.get('global.state') || {};
                if (!state[userId] || $state.current.name.indexOf(type) !== -1) {
                    return;
                }
                if (state[userId][type]) {
                    $state.transitionTo(state[userId][type].url, state[userId][type].query, {
                        reload: false
                    });
                    setTimeout(function() {
                        $($dom.children()[state[userId][type].index]).find('a').click();
                    });
                } else {
                    setTimeout(function() {
                        $($dom.children()[0]).find('a').click();
                    });
                }
            }
        };
    },
]);
